module.exports = __webpack_public_path__ + "media/images/home/about_us/velme_atskirties-a26f98a9f2970ec041095483c98796fc.jpg";